<div class="flex flex-col w-full">
    <div class="flex justify-end mb-4 gap-x-8 text-sm">
        <div class="flex flex-row justify-start items-center gap-x-2">
            <mat-checkbox [formControl]="onlyActiveFilter">
                Only show on hire items
            </mat-checkbox>
        </div>
        <button mat-stroked-button color="primary" (click)="exportToExcel()">
            <mat-icon>download</mat-icon>
            Export to Excel
        </button>
    </div>

    <div class="mat-elevation-z8">
        <div class="loading-shade" *ngIf="loading$ | async">
            <mat-spinner></mat-spinner>
        </div>

        <table mat-table [dataSource]="dataSource" matSort matSortActive="on_hire" matSortDirection="desc">
            <!-- Product Name Column -->
            <ng-container matColumnDef="product_name">
                <th mat-header-cell *matHeaderCellDef>Product Name</th>
                <td mat-cell *matCellDef="let item">
                    <a [routerLink]="['/product', item.product_id, { type: 'hire' }]" matTooltip="View Product">
                        {{ item.product_name }}
                    </a>
                </td>
            </ng-container>

            <!-- Quantity Column -->
            <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef>Qty</th>
                <td mat-cell *matCellDef="let item">{{ item.quantity || 1 }}</td>
            </ng-container>

            <!-- Item Name/Code Column -->
            <ng-container matColumnDef="item_name">
                <th mat-header-cell *matHeaderCellDef>Item Code</th>
                <td mat-cell *matCellDef="let item">{{ item.serial || item.item_name }}</td>
            </ng-container>

            <!-- On Hire Column -->
            <ng-container matColumnDef="on_hire">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>On Hire</th>
                <td mat-cell *matCellDef="let item">
                    {{ item.on_hire | amDateFormat:dateTimeFormat }}
                </td>
            </ng-container>

            <!-- Off Hire Column -->
            <ng-container matColumnDef="off_hire">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Off Hire</th>
                <td mat-cell *matCellDef="let item">
                    <span *ngIf="item.off_hire">{{ item.off_hire | amDateFormat:dateTimeFormat }}</span>
                </td>
            </ng-container>

            <!-- Charge Column -->
            <ng-container matColumnDef="charge">
                <th mat-header-cell *matHeaderCellDef>Charge</th>
                <td mat-cell *matCellDef="let item">{{ item.charge |
                    hlCurrency:item.currency:item.currency_rate:false | async }}</td>
            </ng-container>

            <!-- Docket Status Column -->
            <ng-container matColumnDef="docket_status">
                <th mat-header-cell *matHeaderCellDef>Contract Status</th>
                <td mat-cell *matCellDef="let item">{{ item.docket_status }}</td>
            </ng-container>

            <!-- Docket ID Column -->
            <ng-container matColumnDef="docket_id">
                <th mat-header-cell *matHeaderCellDef>Hire Contract</th>
                <td mat-cell *matCellDef="let item">
                    <a [routerLink]="['/docket', item.docket_id]" matTooltip="View Hire Contract">
                        {{ item.docket_id }}
                        @if (item.account_reference) {
                        ({{ item.account_reference }})
                        }
                    </a>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="8">
                    <div class="flex flex-col w-full justify-start items-stretch text-center">
                        <p class="py-8">
                            <em>This customer has not hired any items yet.</em>
                        </p>
                    </div>
                </td>
            </tr>
        </table>

        <mat-paginator [length]="dataSource.totalCount$ | async" [pageSize]="10"
            [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
</div>